<button
  (click)="onPrevSlide()"
  class="control s-24 button--style-white-04 rounded-full flex items-center justify-center left"
  aria-label="Previous slide"
>
  <svg-icon
    class="w-full flex items-center justify-center"
    src="assets/icons/ui/arrow.svg"
  />
</button>
<button
  (click)="onNextSlide()"
  class="control s-24 button--style-white-04 rounded-full flex items-center justify-center right"
  aria-label="Next slide"
>
  <svg-icon
    class="w-full flex items-center justify-center"
    src="assets/icons/ui/arrow.svg"
  />
</button>

<div #sliderRef class="keen-slider h-full">
  <div class="keen-slider__slide banner first">
    <div class="banner__particles">
      <ngx-particles
        id="homepage-banner-first-particles"
        [options]="particlesOptions"
      ></ngx-particles>
    </div>
    <img
      class="banner--background-image"
      loading="lazy"
      alt="TF2Hunt Banner"
      src="assets/old-images/homepage-guy.png"
    />
    @if (user()) {
    <p class="banner--heading">
      Hey, <span>{{ user()?.name }}</span>
    </p>
    <p class="banner--heading">We have a new rewards system!</p>
    } @else {
    <p class="banner--heading">Welcome to <span> TF2Hunt </span></p>
    }
    <p class="banner--description">Play, wager and claim free money!</p>

    <div class="banner__buttons">
      <div class="banner__badges">
        <div class="banner--badge daily-cases" [routerLink]="'/rewards'">
          Daily Cases
        </div>
        <div class="banner--badge reward-goals" [routerLink]="'/rewards'">
          Reward Goals
        </div>
        <div class="banner--badge rakeback" [routerLink]="'/rewards'">
          RakeBack
        </div>
      </div>

      <button routerLink="/rewards" class="banner--button go-rewards">
        Go to rewards
      </button>
    </div>
  </div>
  <div class="keen-slider__slide banner second">
    <div class="banner__particles">
      <ngx-particles
        id="homepage-banner-second-particles"
        [options]="particlesOptions"
      ></ngx-particles>
    </div>
    <img
      class="banner--background-image"
      loading="lazy"
      alt="TF2Hunt Rain Banner"
      src="assets/old-images/man-with-money.png"
    />
    <p class="banner--heading yellow">Rain</p>
    <p class="banner--description">Play, wager and claim free money!</p>
    <div class="banner__buttons">
      @if (rainService.rain().state === 1 || rainService.rain().state === 2) {
      <button
        @fadeInAnimation
        class="banner--button tip-rain"
        (click)="openTipRainModal()"
      >
        Tip Rain
      </button>
      } @if (rainService.rain().state === 2) {
      <button
        @fadeInAnimation
        class="banner--button join-rain"
        type="button"
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        (click)="openOverlay()"
      >
        Join Rain
      </button>
      @let rainCaptcha = rainService.rain().captcha; @if (rainCaptcha) {
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOrigin]="trigger"
        [cdkConnectedOverlayOpen]="isCaptchaOverlay"
        (detach)="isCaptchaOverlay = false"
        cdkConnectedOverlayPanelClass="context-menu-panel"
      >
        <app-captcha-overlay
          [captcha]="rainCaptcha"
          (closeCaptchaOverlay)="isCaptchaOverlay = false"
          (verifyCaptcha)="handleVerifyCaptcha($event)"
        ></app-captcha-overlay>
      </ng-template>
      } }
    </div>
  </div>
</div>
